import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import React from "react";
import HttpClient from "../../lib/HttpClient";
import { useSnackbarContext } from "../../contexts/Snackbar";

interface ConfirmDeleteProfileDailogInterface {
  patientId: string;
  onProfileDeletedFn: () => void;
  onDailogCanceledFn: () => void;
}

const ConfirmDeleteProfileDialog = ({
  patientId,
  onProfileDeletedFn,
  onDailogCanceledFn,
}: ConfirmDeleteProfileDailogInterface) => {
  const { setSnackbar } = useSnackbarContext();

  function deleteProfile(patientId: string) {
    HttpClient.performPut<any>(`/api/v1/users/${patientId}`)
      .then(({ body }) => {
        if (body) {
          console.log(body);
          if (body.status.success) {
            setSnackbar({
              message: "Profile deleted",
              severity: "success",
            });
            onProfileDeletedFn();
          } else {
            setSnackbar({
              message: body?.status?.message ?? "Unable to delete profile",
              severity: "error",
            });
          }
        } else {
          setSnackbar({
            message: body?.status?.message ?? "Profile not found",
            severity: "error",
          });
        }
      })
      .catch((e) => {
        setSnackbar({
          message: e.body?.status?.message,
          severity: "error",
        });
      });
  }

  return (
    <Dialog
      open={true}
      onClose={() => onDailogCanceledFn()}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{"Delete Profile"}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Are you sure to delete this profile?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onDailogCanceledFn()}>No</Button>
        <Button
          onClick={() => {
            deleteProfile(patientId);
          }}
          autoFocus
        >
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDeleteProfileDialog;
